import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const FeedsSlider = ({
  children,
  records = [],
  renderItem,
  slotFeedsSlider,
  renderWithProvider,
  containerClassName
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const maxLength = Math.max(records.length - 1, 0);

  const nextPlaylist = () => {
    if (activeIndex < maxLength) {
      setActiveIndex(activeIndex + 1);
    } else {
      setActiveIndex(0);
    }
  };

  const prevPlaylist = () => {
    if (activeIndex < maxLength + 1 && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    } else {
      setActiveIndex(maxLength);
    }
  };

  const renderPagination = () => {
    if (maxLength === 0) {
      return null;
    }

    const showNextButton = activeIndex !== maxLength;
    const showPrevButton = activeIndex !== 0;

    return (
      <React.Fragment>
        {showNextButton && (
          <div className="feeds-slider-button next" onClick={() => nextPlaylist()}/>
        )}
        {showPrevButton && (
          <div className="feeds-slider-button prev" onClick={() => prevPlaylist()}/>
        )}
        <div className="feeds-slider-pagination">
          {records.map((_, index) => {
            return (
              <span
                onClick={() => setActiveIndex(index)}
                key={index}
                className={classNames("feeds-slider-pagination-bullet", {
                  "active": index === activeIndex
                })}
              />
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  const renderItems = () => {
    const renderedItems = records.map( (item, index) => {

      return (
        <div key={index} className={classNames("feeds-slider-item", {
          "active": activeIndex === index
        })}>
          {renderItem({item})}
        </div>
      );
    });

    if (renderWithProvider && typeof renderWithProvider === "function") {
      return renderWithProvider(renderedItems);
    }

    return renderedItems;
  };

  return (
    <div className={classNames("feeds-slider-container", containerClassName)}>
      <div className="feeds-slider">
        {!!records.length && (
          <div
            className="feeds-slider-wrapper"
            style={{ "transform": `translateX(-${ activeIndex * 100}%)` }}
          >
            {renderItems()}
          </div>
        )}
        {slotFeedsSlider}
      </div>
      {renderPagination()}
      {children}
    </div>
  );
};

FeedsSlider.propTypes = {
  children: PropTypes.node,
  slotFeedsSlider: PropTypes.node,
  records: PropTypes.array,
  renderItem: PropTypes.func,
  renderWithProvider: PropTypes.func,
  containerClassName: PropTypes.string
};

export default FeedsSlider;
